<template>
  <div class="g-box comment-item">
    <slot name="start" />
    <UserItem :avatar="target.UserInfo.avatar" :name="target.UserInfo.name" :ont="target.UserInfo.ontid" />
    <div class="content">{{ target.content }}</div>
    <div v-if="showReply" class="reply" @click="switchShowComments">
      <i class="iconfont iconhuifu reply__icon"></i>
      <span class="g-font-mid reply__label">{{ $t('bounty.reply') }}</span>
    </div>
    <div class="time">{{ target.createdAt | formatTime }}</div>
    <NouFoldTransition>
      <SubComment v-if="showComments" :target="target" @login="$emit('login')" />
    </NouFoldTransition>
  </div>
</template>

<script>
import UserItem from '@/components/UserItem.vue';
import SubComment from '@/views/Bounty/SubComment.vue';

export default {
  name: 'CommentItem',
  components: { SubComment, UserItem },
  props: {
    target: {
      type: Object,
      require: false,
      default: null,
    },
    showReply: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  data() {
    return {
      showComments: false,
    };
  },
  methods: {
    switchShowComments() {
      this.showComments = !this.showComments;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/styles/var.scss';

  .comment-item {
    position: relative;
    margin-bottom: $padding-sm;
    padding: $padding-common;
  }

  .content {
    margin-top: $padding-common;
    line-height: 22px;
  }

  .reply {
    float: right;
    margin-top: $padding-common;
    line-height: 20px;
    cursor: pointer;
  }

  .reply__icon {
    vertical-align: middle;
  }

  .reply__label {
    margin-left: 10px;
  }

  .time {
    margin-top: $padding-common;
    color: var(--color-content);
    line-height: 20px;
  }
</style>
